import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../common/global-variables';
import { Service } from '../network.service';
let $ = require('jquery');
import { AppState } from '../../../app.service';
import { NgForm } from '@angular/forms';
import { ConnectGatewayWizard } from './wizards/connect-gateway/connect-gateway.wizard';
import { Subscription } from 'rxjs/Rx';
import { RefreshSharedService } from '../../../refresh-shared-service';
const _ = require('lodash');

@Component({
  selector: 'direct-connect',
  styles: [require('./direct-connect.scss')],
  template: require('./direct-connect.html'),
  providers: [
    Service, TranslateService
  ]
})

export class DirectConnect {
  @Input('isVisible') isVisible: boolean;

  private dcList: any;
  private dcProcessedData: Array<any> = [];
  private isTranslationready: boolean = true;
  private subscribeHandler;
  private isConnectGatewayWizardVisible: boolean = false;
  private isConnectNetworkVisible: boolean = false;
  private isEditGatewayWizardVisible: boolean = false;
  private vdcIdFromRoute: string = '';
  private isEdit: boolean = false;
  private orgVdcId: string = '';
  private rowData: any;
  private createData: any;
  private editData: any;
  private isEditNetwork: any;
  private directConnectName: string = '';
  private isDisconnectGatewayVisible: boolean = false;
  private loaded: boolean = false;
  private cardClass: string = "";
  private rsService: RefreshSharedService;
  private refreshSubscription: Subscription;
  private currentClassName: string = '';

  constructor(public appState: AppState,
              public service: Service,
              private translate: TranslateService,
              private rss: RefreshSharedService) {
        translate.use(GlobalVariables.LOCALE);
        this.loaded = false;
        this.rsService = rss;
        this.currentClassName = 'DirectConnect';
   }

  ngOnInit() {
      this.refreshSubscription = this.rsService.getRefreshParam()
      .subscribe (
        item => {
          this.handleEmittedValues(item);
      });

    this.rsService.setParam({
        'loadedComponent': this.currentClassName,
        'detailPageIDName': '',
        'shouldReloadInventoryTree': true
      });
    this.getDirectConnectList();
  }

  handleEmittedValues(item) {
    if (item.loadedComponent === this.currentClassName) {
      this.dcList = [];
      this.dcProcessedData = []
      this.getDirectConnectList();
    }
  }

  getDirectConnectList() {
    this.dcProcessedData = [];
    this.loaded = false;
    this.subscribeHandler = this.service.getDirectConnectList()
    .subscribe(
      (dcList: any) => {
        this.dcList = dcList.directConnects;
        this.dcProcessedData = this.service.processData(this.dcList);
        this.loaded = true;
      },
      error => this.service.logError(error, 'get Direct Connect error'),
      () => this.service.logOperationCompleted('get Direct Connect Completed')
    );
  }

  showConnectGatewayWizard(rowData: any) {
    this.createData = _.cloneDeep(rowData);
    this.isConnectGatewayWizardVisible = true;

  }

  showConnectNetworkDialog(rowData: any, directConnectName: string) {
    this.createData = {'rowData': _.cloneDeep(rowData)};
    this.isConnectNetworkVisible = true;
    this.isEditNetwork = false;
    this.directConnectName = directConnectName;
  }

  showDisconnectGatewayDialog(rowData: any, edge: any, directConnectName: string, edgeName: string) {
    this.createData = {
      rowData: _.cloneDeep(rowData),
      edge: _.cloneDeep(edge),
      directConnectName: directConnectName,
      edgeName: edgeName
    };
    this.isDisconnectGatewayVisible = true;
    this.directConnectName = directConnectName;
  }

  showEditNetworkDialog(rowData: any, subnet: any, directConnectName: string) {
    this.createData = {
        rowData: _.cloneDeep(rowData),
        subnet: _.cloneDeep(subnet),
        directConnectName: directConnectName
      };
    this.directConnectName = directConnectName;
    this.isConnectNetworkVisible = true;
    this.isEditNetwork = true;
  }

  onConnectNetworkClose(event) {
    if (event && event.value) {
      this.isConnectNetworkVisible = false;
      this.isEditNetwork = false;
    }
  }

  onDisconnectGatewayClose(event) {
    if (event && event.value) {
      this.isDisconnectGatewayVisible = false;
    }
  }

  showEditGatewayWizard(rowData: any, edge: any) {
    this.editData = {rowData: _.cloneDeep(rowData), edge: edge};
    this.isEditGatewayWizardVisible = true;
  }

  connectWizardStatusChange(event) {
    this.isConnectGatewayWizardVisible = event;
    this.isEdit = false;
    this.orgVdcId = '';
  }

  editWizardStatusChange(event) {
    this.isEditGatewayWizardVisible = event;
    this.isEdit = false;
    this.orgVdcId = '';
  }

  getTitle() {
      return (this.translate.instant('directConnect.directConnects'));
  }

  ngOnDestroy() {
    this.rsService.resetParam();
    if (this.refreshSubscription) {
        this.refreshSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/network/direct-connect/direct-connect.ts